import { Card } from "react-bootstrap";

const DettaglioPianoCard = () => {
	const features = [
		{
			icon: "fas fa-calculator",
			text: "Servizio POS Spending.",
			id: 1,
		},
		{
			icon: "fas fa-newspaper",
			text: "Mandato all'incasso.",
			id: 2,
		},
	];
	return (
		<Card className="shadow background-gray">
			<Card.Body>
				<h5 className="m-3">Il piano scelto include:</h5>
				<div className="mx-3 mb-3">
					{features.map((feature, index) => (
						<div className="d-flex align-items-center mb-3" key={`feature${feature.id}`}>
							<div className="justify-content-start square-icon-shadow icon-card-v2">
								<div className="square-icon-container">
									<i className={`${feature.icon} square-icon`}></i>
								</div>
							</div>
							<div className="text-left ps-3">
								<span className="gray m-0">
									<small>{feature.text}</small>
								</span>
							</div>
						</div>
					))}
					{/* 					<BftButton isDisabled className="btn-buffetti-secondary col-12">
						Cambia piano
					</BftButton> */}
				</div>
			</Card.Body>
		</Card>
	);
};

export default DettaglioPianoCard;
